import React from "react";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import { PanelLayout } from "../../../layout/Panel/Panel";
import { Spacing } from "../../../layout/Spacing/Spacing";
import { SpacingCustom } from "../../../layout/Spacing/SpacingCustom";
import IconComponent from "../../../shared/IconComponents/IconComponent";
import { TextCustom } from "../../../ui/TextCustom";


export const DashboardListWarning = () => {
    return (
        <SpacingCustom paddingTop={1}>
            <PanelLayout color="white" hasShadow={false}>
                <Spacing paddingSpacing="l" marginSpacing="none">
                    <FlexCenter direction="v" gap={1}>
                        <IconComponent size={2} iconName={'Warning_02'} />
                        <FlexCenter direction="v" gap={.5}>
                            <TextCustom size={1.2} color="dark">Dashboard list is empty.</TextCustom>
                        </FlexCenter>
                    </FlexCenter>
                </Spacing>
            </PanelLayout>
        </SpacingCustom>
    )
}